// 横項目目录。来源 Pixso 5300:19011 請求書印刷＿B 右侧列表。
var EXTRA_ITEM_CATALOG = [
  '庭維持費',
  'エアコン洗浄',
  '害虫駆除',
  '固定資産税',
  '町内会費',
  'インターネット',
  '光熱費（水道ガス電気）',
  '備品買い替え（家電や布団など）',
  '建物修繕費',
  '家電メンテナンス費用',
  '乙負担に含まれない実費',
  '火災保険費',
  '地代',
  'サイトコントローラー費',
  '施設外帳場スタッフ待機費用',
  'ゴミ収集'
];

export default EXTRA_ITEM_CATALOG;
